import { render, staticRenderFns } from "./invoiceTop.vue?vue&type=template&id=2cdd4815&scoped=true&"
import script from "./invoiceTop.vue?vue&type=script&lang=js&"
export * from "./invoiceTop.vue?vue&type=script&lang=js&"
import style0 from "./invoiceTop.vue?vue&type=style&index=0&id=2cdd4815&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdd4815",
  null
  
)

export default component.exports